import {
  DECREMENT_STEP_MODAL,
  ERROR_UPDATE_MISSION,
  INCREMENT_STEP_MODAL,
  RECEIVED_MISSIONS,
  RECEIVED_UPDATE_MISSION,
  RESET_STEP_MODAL,
  STEP_MODAL_CLOSE,
  STEP_MODAL_OPEN,
  TOGGLE_STEP_MODAL_OPEN,
  UPDATE_STEP_MODAL_ACTION,
  UPDATE_STEP_MODAL_AGREEMENT,
  UPDATED_FUNDING_METHOD,
  RESET_FUNDING_METHOD
} from 'state/missions/MissionActions';

export const missionsReducer = (state = [], action) => {
  const { type } = action;

  if (type === RECEIVED_MISSIONS) {
    const { missions } = action;
    if (missions) {
      return missions;
    }
  }

  return state;
};

export const missionUpdateReducer = (state = {}, action) => {
  const { type } = action;

  if (type === RECEIVED_UPDATE_MISSION) {
    const { result } = action;
    if (result) {
      return {
        ...state,
        result,
        lastUpdate: new Date().getTime()
      };
    }
  }
  if (type === ERROR_UPDATE_MISSION) {
    const { error } = action;
    return {
      ...state,
      error
    };
  }

  return state;
};

export const fundingMethodReducer = (state = FUNDING_METHOD_INITIAL_STATE, action = {}) => {
  if (action.type === UPDATED_FUNDING_METHOD) {
    if (action.fundingMethod) {
      return action.fundingMethod;
    }
    return state;
  } else if (action.type === RESET_FUNDING_METHOD) {
    return FUNDING_METHOD_INITIAL_STATE;
  }
  return state;
};

export const STEP_MODAL_INITIAL_STATE = {
  action: 'FUNDING',
  agreementID: '',
  step: 0,
  open: false
};

export const FUNDING_METHOD_INITIAL_STATE = 'DEFAULT'

export const stepModalReducer = (
  state = STEP_MODAL_INITIAL_STATE,
  action = {}
) => {
  if (action.type === UPDATE_STEP_MODAL_ACTION) {
    return {
      ...state,
      action: action.action
    };
  }
  if (action.type === UPDATE_STEP_MODAL_AGREEMENT) {
    return {
      ...state,
      agreementID: action.agreementID
    };
  }
  if (action.type === TOGGLE_STEP_MODAL_OPEN) {
    return {
      ...state,
      open: !state.open
    };
  }
  if (action.type === STEP_MODAL_OPEN) {
    return {
      ...state,
      open: true
    };
  }
  if (action.type === STEP_MODAL_CLOSE) {
    return {
      ...state,
      open: false
    };
  }
  if (action.type === INCREMENT_STEP_MODAL) {
    return {
      ...state,
      step: state.step + 1
    };
  }
  if (action.type === DECREMENT_STEP_MODAL) {
    return {
      ...state,
      step: state.step - 1
    };
  }
  if (action.type === RESET_STEP_MODAL) {
    return STEP_MODAL_INITIAL_STATE;
  }
  return state;
};
